import { connect } from 'react-redux';
import DisplayActions from '../../../../redux/DisplayRedux';
import CampaignAsyncOperationModal from '../components/CampaignAsyncOperationModal';

const mapStateToProps = ({ display }) => ({
  asyncOperation: display.campaignAsyncOperation,
  retrying: display.retryingCampaignAsyncOperation,
  errors: display.errors,
  creationType: display.creationType
});

const mapStateToDispatch = dispatch => ({
  retry: (campaignId, operationId) =>
    dispatch(DisplayActions.retryCampaignAsyncOperationRequest(campaignId, operationId)),
  close: () => dispatch(DisplayActions.clearCampaignAsyncOperation())
});

export default connect(mapStateToProps, mapStateToDispatch)(CampaignAsyncOperationModal);
